$(document).ready(function () {

  function setEqualHeights1(selector) {
    var maxHeight = 0;
    var $elements = $(selector);

    if ($elements.length === 0) return false;

    // reset first
    $elements.css("height", "auto");

    $elements.each(function () {
      var h = $(this).outerHeight();
      if (h > maxHeight) maxHeight = h;
    });

    if (maxHeight > 0) {
      $elements.css("height", maxHeight + "px");
      return true;
    }

    return false;
  }

  function init1() {
    setEqualHeights1(".card-wrapper .gb-cart-content .gb-card-information-main .card__heading a");
    setEqualHeights1(".gb-featured-collection .card-wrapper .gb-cart-content .gb-card-information-main .card__heading a");
    setEqualHeights1(".card-wrapper .gb-cart-content .gb-card-information-main .gb-product__excerpt");
    setEqualHeights1(".gb-featured-collection .card-wrapper .gb-cart-content .gb-card-information-main .gb-product__excerpt");


  }

  // FIRST run
  init1();

  // on resize
  $(window).on("resize", init1);

  // ✅ POLLING: keep checking until heights > 0 (max 8 seconds)
  let attempts = 0;
  const poll = setInterval(function () {
    attempts++;
    init1();

    // check if height applied correctly
    if ($(".card-wrapper .gb-cart-content .gb-card-information-main .card__heading a").outerHeight() > 0 || attempts > 15) {
      clearInterval(poll);
    }
  }, 1000);

});





$(document).ready(function () {
  function setEqualHeights() {
    var maxHeight = 0;

    // reset heights first
    $(".mv-container .mv-box .mv-text")
      .css("height", "auto");

    // find max height
    $(".mv-container .mv-box .mv-text").each(function () {
      var thisHeight = $(this).outerHeight();
      if (thisHeight > maxHeight) {
        maxHeight = thisHeight;
      }
    });

    // apply max height to all
    $(".mv-container .mv-box .mv-text")
      .css("height", maxHeight + "px");
  }

  // run on load
  setEqualHeights();

  // run again on resize
  $(window).on("resize", function () {
    setEqualHeights();
  });
});
